import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isValidNumber',
  standalone: true,
})
export class IsValidNumberPipe implements PipeTransform {
  transform(value: any): boolean {
    return value !== null && !isNaN(value);
  }
}
